import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { PopupItem } from 'src/classes/Common/PopupItem';
import { Screen } from '../../../../classes/Authorization/BusinessRole';
import { Worker } from 'src/classes/Common/Worker';
import { Appointment, AppointmentCopyCutDelIn, AppointmentData, AppointmentDetailsIn, AppointmentIn, NextSlotIn } from 'src/classes/Diary/Appointment';
import { CustomerIn } from 'src/classes/Customers/CustCard_1';
import { StaticSymbolResolver } from '@angular/compiler';
import * as moment from 'moment';
import { CustomerAppointmentLazy, CustomerAppointmentLazySearch } from 'src/classes/Diary/CustomerAppointment';

@Injectable()
export class HttpServiceDiary {
    error_post: string;

    constructor(private http: HttpClient) { }

    getAppointmentsbyPost(appointmentIn: AppointmentIn) {
        const body = {
            dateVisitFrom: appointmentIn.dateVisitFrom,
            dateVisitTo: appointmentIn.dateVisitTo,
            dateVisitFrom_1: appointmentIn.dateVisitFrom_1,
            dateVisitTo_1: appointmentIn.dateVisitTo_1,
            smsSendingResult: appointmentIn.smsSendingResult
        };

        return this.http.post(environment.urlservbeautech + '/api/Diary/GetAppointments', JSON.stringify(body));
    }


    getAppointmentsCachebyPost(appointmentIn: AppointmentIn) {
        const body = {
            dateVisitFrom: appointmentIn.dateVisitFrom,
            dateVisitTo: appointmentIn.dateVisitTo,
            dateVisitFrom_1: appointmentIn.dateVisitFrom_1,
            dateVisitTo_1: appointmentIn.dateVisitTo_1,
            smsSendingResult: appointmentIn.smsSendingResult
        };

        return this.http.post(environment.urlservbeautech + '/api/Diary/GetAppointmentsCache', JSON.stringify(body));
    }




    getWorkers() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Diary/GetWorkers')
    }

    getInvalidTime(appointmentIn: AppointmentIn) {
        const body = {
            dateVisitFrom: appointmentIn.dateVisitFrom,
            dateVisitTo: appointmentIn.dateVisitTo,
            dateVisitFrom_1: appointmentIn.dateVisitFrom_1,
            dateVisitTo_1: appointmentIn.dateVisitTo_1,
            smsSendingResult: appointmentIn.smsSendingResult
        };

        return this.http.post(environment.urlservbeautech + '/api/Diary/GetInvalidTime', JSON.stringify(body));
    }


    getItemsMenuByScreen(screen: Screen) {
        const body = { screen_id: screen.screen_id };
        return this.http.post(environment.urlservbeautech + '/api/Customers/GetMenuItemsSync', JSON.stringify(body));
    }

    getConfigDiary() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Diary/GetConfigSync')
    }


    async setWorkersMobile(Workers: Worker[]) {
        let json = JSON.stringify(Workers);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/Diary/SetWorkerShowMobile', body).toPromise(); //JSON.stringify(body));
    }


    getAppointmentDetails(appdetin: AppointmentDetailsIn) {
        const body = { yomanId: appdetin.yomanId };
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetAppointmentDetails', JSON.stringify(body));
    }



    async setEventCopyCutDel(eventup: AppointmentCopyCutDelIn) {
        let json = JSON.stringify(eventup);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/Diary/SetAppCopyCutDel', body).toPromise();
    }

    getCustomersAppointment() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Diary/GetCustomersAppointment')
    }

    getDepartmentsServices(appdata: AppointmentData) {
        let json = JSON.stringify(appdata);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetDepartmentsServices', body).toPromise();
    }


    getStatusesApp() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Diary/GetStatusesAppointment')
    }

    getCancelationReasons() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Diary/GetCancelationReasons')
    }

    async setEventNew(eventup: AppointmentData) {
        const eventCopy = { ...eventup };

        eventCopy.start = moment(eventCopy.start as Date).format("MM/DD/YYYY, HH:mm");
        eventCopy.end = moment(eventCopy.end as Date).format("MM/DD/YYYY, HH:mm");

        let json = JSON.stringify(eventCopy);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/Diary/SetAppNew', body).toPromise();
    }


    getCustomersAppointmentById(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetCustomerAppointmentById', JSON.stringify(body));
    }



    getServicesByAppointmentId(appdetin: AppointmentDetailsIn) {
        const body = { yomanId: appdetin.yomanId };
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetServicesByEventId', JSON.stringify(body));
    }


    getAppointmentDetailsSummaryStep(appdetin: AppointmentDetailsIn) {
        const body = { yomanId: appdetin.yomanId };
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetAppointmentDetailsSummaryStep', JSON.stringify(body));
    }


    getStartNextSlot(nextslotin: NextSlotIn) {
        const body = { saparId: nextslotin.saparId, startEvent:nextslotin.startEvent };
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetStartNextSlot', JSON.stringify(body));
    }


    getCustomersAppointmentLazy(customerappointmentlazy: CustomerAppointmentLazy) {
        const body = {
            page: customerappointmentlazy.page,
            size: customerappointmentlazy.size,
            sortField: customerappointmentlazy.sortField,
            sortOrder: customerappointmentlazy.sortOrder
        };
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetCustomersAppointmentLazy', JSON.stringify(body)).toPromise();
    }

    getCustomersAppointmentLazySearch(customerappointmentlazysearch: CustomerAppointmentLazySearch) {
        const body = {
            page: customerappointmentlazysearch.page,
            size: customerappointmentlazysearch.size,
            sortField: customerappointmentlazysearch.sortField,
            sortOrder: customerappointmentlazysearch.sortOrder,
            search: customerappointmentlazysearch.search
        };
        return this.http.post(environment.urlservbeautech + '/api/Diary/GetCustomersAppointmentLazySearch', JSON.stringify(body)).toPromise();
    }
}